<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre4">Personen und ihre Masken</h1>
<p class="calibre1"><span class="speaker">Epidicus</span>, Sklave</p>
<p class="calibre1"><span class="speaker">Thesprio</span>, Sklave</p>
<p class="calibre1"><span class="speaker">Stratippocles</span>, junger Mann</p>
<p class="calibre1"><span class="speaker">Chaeribulus</span>, junger Mann</p>
<p class="calibre1"><span class="speaker">Periphane</span>s, alter Mann</p>
<p class="calibre1"><span class="speaker">Apoecides</span>, alter Mann</p>
<p class="calibre1"><span class="speaker">Ein Sklave</span></p>
<p class="calibre1"><span class="speaker">Eine Harfenspielerin</span></p>
<p class="calibre1"><span class="speaker">Ein Söldner</span></p>
<p class="calibre1"><span class="speaker">Philippa</span>, Frau aus Theben</p>
<p class="calibre1"><span class="speaker">Acropolistis</span>, Harfenspielerin</p>
<p class="calibre1"><span class="speaker">Ein Geldverleiher</span></p>
<p class="calibre1"><span class="speaker">Telestis</span>, Jungfrau</p>
<p class="calibre1"><span>Ort der Handlung: Athen</span></p>
<p class="calibre1">Die Szene zeigt die Vorderseite zweier Häuser, das Haus des Periphanes und das des Chaeribulus</p>
<p class="calibre1"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?7347f97f